var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
var EditableCell = function (_a) {
    var initialValue = _a.value, _b = _a.row, index = _b.index, originalDomainObj = _b.original, id = _a.column.id, handleUpdate = _a.handleUpdate, _c = _a.numeric, numeric = _c === void 0 ? false : _c;
    var _d = useState(initialValue), value = _d[0], setValue = _d[1];
    var _e = useState({}), updatedDomainObj = _e[0], setUpdatedDomainObj = _e[1];
    var onChange = function (e) {
        var update = __assign({}, originalDomainObj);
        update[id] = e.target.value;
        setUpdatedDomainObj(update);
        setValue(e.target.value);
    };
    var onBlur = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(updatedDomainObj !== originalDomainObj)) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleUpdate(updatedDomainObj)];
                case 1:
                    _a.sent();
                    setUpdatedDomainObj({});
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setValue(initialValue);
        setUpdatedDomainObj(originalDomainObj);
    }, [initialValue]);
    useEffect(function () {
        setUpdatedDomainObj(originalDomainObj);
    }, [originalDomainObj]);
    return numeric ? (_jsxs("div", __assign({ className: "flex text-gray-500" }, { children: [_jsx("span", __assign({ className: "inline-flex items-center pl-3 text-sm" }, { children: "$" }), void 0), _jsx("input", { type: "number", min: 0, value: value, onChange: onChange, onBlur: onBlur, className: "pl-0.5 w-full h-full bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-50" }, void 0)] }), void 0))
        : _jsx("input", { type: "text", value: value, onChange: onChange, onBlur: onBlur, className: "text-gray-500 w-full h-full bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-50" }, void 0);
};
export default EditableCell;
